import React from "react";
import { Button, message, Dropdown, Menu } from "antd";
import { DataTable } from "./DataTable";
import { YhBox } from "@/components/YhBox";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import { useMaintenanceModel } from "../maintenanceModel";
import useNavModel from "@/model/navModel";
import { globalPrompt } from "@/components/message";
import { useMaintenanceDetailsModel } from "./details/maintenanceDetailsModel";
import { AuthButton } from "@/components/auth/AuthButton";
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
import { ResourcesAuthBtn } from "@/types/ResourcesAuthEnum";
import { mianCode } from "@/utils/constants";
import { DownOutlined } from '@ant-design/icons';
import { formatNum } from "@/utils/utils";
import { chargebackApprovalAndPass } from "../maintenanceTypes";

export const DataBox = () => {
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)

    const { selectedRowKeys, selectedRow, descTotal, rowsDescTotal,
        invalidateData, setPrint, loadData, setSettleVisible, setOfferPrint, setSalePrint, detailsExport, listExport,
        chargebackApproval,
        chargebackPassed
    } = useMaintenanceModel();
    const { setDetailEditForm, setDetailItemEditList, setDetailMaterialEditList, WhConfirm } = useMaintenanceDetailsModel();

    const { selectedNavId, addNav, findNav, selectNav, switchNavState, replaceNav } = useNavModel();
    const onEdit = () => {
        if (selectedRowKeys.length !== 1) {
            // globalPrompt("message", { text: "请选择单条数据进行编辑", type: "warning" });
            globalPrompt("message", { text: Locale["Please select a single piece of data for editing."], type: "warning" });
            return;
        }
        if (selectedRow.status === "maintenance.settle") {
            // globalPrompt("message", { text: "该单据已结算，无法进行编辑", type: "warning" });
            globalPrompt("message", { text: Locale["The document has been settled and cannot be edited."], type: "warning" });
            return;
        }
        if (selectedRow.status === "maintenance.stock-io") {
            // globalPrompt("message", { text: "该单据已出库，无法进行编辑", type: "warning" });
            globalPrompt("message", { text: Locale["The document has been stocked out and cannot be edited."], type: "warning" });
            return;
        }
        if (selectedRow.status === "maintenance.change") {
            // globalPrompt("message", { text: "该单据已作废，无法进行编辑", type: "warning" });
            globalPrompt("message", { text: Locale["The document has been cancelled and cannot be edited."], type: "warning" });
            return;
        }
        let saleSoEditKey = "2-2-2";
        let isFindNav = findNav(saleSoEditKey);
        if (!isFindNav) {
            addNav(saleSoEditKey, { id: selectedRow.maintenanceCode as string, mode: "edit" });
        } else {
            globalPrompt("modal", {
                // title: "维修单跳转详情",
                title: Locale["Jump to the detail page of maintenance doc."],
                type: "warning",
                // text: "您还有维修单详情未保存，是否跳转",
                text: Locale["The detail page of maintenance doc has not been saved. Do you still want to jump?"],
                // okText: "跳转未保存页",
                okText: Locale["Jump to the unsaved page"],
                onOk: () => selectNav(isFindNav ? isFindNav.id : ""),
                // cancelText: "打开新页签",
                cancelText: Locale["Open a new page"],
                onCancel: () => {
                    switchNavState(saleSoEditKey, { id: selectedRow.maintenanceCode as string, mode: "edit" });
                    setDetailEditForm({});
                    setDetailItemEditList([]);
                    setDetailMaterialEditList([])
                    // updateEditFormVal(null);
                }
            })
        }
    }
    const onLook = () => {
        if (selectedRowKeys.length !== 1) {
            // globalPrompt("message", { text: "请选择单条数据进行查看", type: "warning" });
            globalPrompt("message", { text: Locale["Please select a single piece of data to view."], type: "warning" });
            return;
        }
        let supplierEditKey = "2-2-3";
        replaceNav(
            selectedNavId,
            "2-2-3",
            { id: selectedRow.maintenanceCode as string, mode: "look", },
            true
        );
    }
    const cancellation = async () => {
        if (selectedRowKeys.length !== 1) {
            // globalPrompt("message", { text: "请选择单条数据进行作废", type: "warning" });
            globalPrompt("message", { text: Locale["Please select a single piece of data for cancellation."], type: "warning" });
            return;
        }
        let val: string = ""
        globalPrompt("modal", {
            // title: "维修单作废",
            title: Locale["Cancel the maintenance doc."],
            type: "error",
            text: "",
            // <><span>请输入作废原因</span>
            //     <Input onChange={(e) => { val = e.target.value }} /></>,
            // okText: "确定",
            okText: Locale["Yes No"],
            onOk: () => {
                let obj = {
                    id: selectedRow.id,
                    maintenanceCode: selectedRow.maintenanceCode
                    // val
                }
                invalidateData(obj)
            },
            // cancelText: "取消",
            cancelText: Locale["cancel"],
            onCancel: () => {
            }
        })
    }
    const passed = async () => {
        if (selectedRowKeys.length !== 1) {
            // globalPrompt("message", { text: "请选择单条数据进行编辑", type: "warning" });
            globalPrompt("message", { text: Locale["Please select a single piece of data for editing."], type: "warning" });
            return;
        }
        if (selectedRow.returnType !== "maintenance.chargeback.pend") {
            // globalPrompt("message", { text: "该订单不是退单审核状态，无法进行审核", type: "warning" });
            globalPrompt("message", { text: Locale["The document is not in the maintenance return state of approving, so it cannot be approve."], type: "warning" });
            return;
        }
        chargebackPassed({
            id: selectedRow.id,
            maintenanceCode: selectedRow.maintenanceCode
        } as chargebackApprovalAndPass)
    }
    const approval = async () => {
        if (selectedRowKeys.length !== 1) {
            // globalPrompt("message", { text: "请选择单条数据进行编辑", type: "warning" });
            globalPrompt("message", { text: Locale["Please select a single piece of data for editing."], type: "warning" });
            return;
        }
        if (!(selectedRow.status === "maintenance.stock-io" && selectedRow.returnType === null)) {
            // globalPrompt("message", { text: "该单据不是已结算，退单审核初始状态，无法进行编辑", type: "warning" });
            globalPrompt("message", { text: Locale["The document is not Stock out and is not in the maintenance return state of pending-approving, so it cannot be edited."], type: "warning" });
            return;
        }
        chargebackApproval({
            id: selectedRow.id,
            maintenanceCode: selectedRow.maintenanceCode
        } as chargebackApprovalAndPass)

    }
    const onSettle = async () => {
        if (selectedRowKeys.length !== 1) {
            // globalPrompt("message", { text: "请选择单条数据进行操作", type: "warning" });
            globalPrompt("message", { text: Locale["Please select a single piece of data for editing."], type: "warning" });
            return;
        }

        setSettleVisible(true)
    }
    const onWhConfirm = async () => {
        if (selectedRowKeys.length !== 1) {
            // globalPrompt("message", { text: "请选择单条数据进行操作", type: "warning" });
            globalPrompt("message", { text: Locale["Please select a single piece of data for editing."], type: "warning" });

            return;
        }
        let { maintenanceCode, id } = selectedRow
        globalPrompt("modal", {
            // title: "维修单出库",
            title: Locale["Stock out the maintenance doc."],
            type: "success",
            text: "",
            // okText: "确定",
            okText: Locale["Yes No"],
            onOk: async () => {
                let retData = await WhConfirm({ maintenanceCode, id })
                // retData ? message.success("出库成功") && loadData() : message.error("出库失败")
                retData ? message.success(Locale["Successfully stocked out"]) && loadData() : message.error(Locale["Unsuccessfully stocked out"])
            },
            // cancelText: "取消",
            cancelText: Locale["cancel"],
            onCancel: () => {
            }
        })
    }
    const onQuotationPrint = () => {
        if (selectedRowKeys.length !== 1) {
            // globalPrompt("message", { text: "请选择单条数据进行操作", type: "warning" });
            globalPrompt("message", { text: Locale["Please select a single piece of data for editing."], type: "warning" });
            return;
        }
        setOfferPrint(true)
    }

    const onSaleBillPrint = () => {
        if (selectedRowKeys.length !== 1) {
            // globalPrompt("message", { text: "请选择单条数据进行操作", type: "warning" });
            globalPrompt("message", { text: Locale["Please select a single piece of data for editing."], type: "warning" });
            return;
        }
        setSalePrint(true)
    }
    const MenuExport = () => {
        return (
            <Menu>
                <Menu.Item key="0">
                    <span onClick={listExport}>{Locale["List export"]}</span>
                </Menu.Item>
                <Menu.Item key="1">
                    <span onClick={detailsExport}>{Locale["Details export"]}</span>
                </Menu.Item>
            </Menu>
        )
    }
    const action = <>
        <AuthButton
            // resCode="maintenanceAdd"
            resCode={ResourcesAuthBtn[mianCode]["MaintenanceAdd"]}
            onClick={() => addNav("2-2-1", { id: "", mode: "add" })}
            // name="新增"
            name={Locale["Add"]}

        />
        <AuthButton
            // resCode="maintenanceEdit"
            resCode={ResourcesAuthBtn[mianCode]["MaintenanceEdit"]}
            onClick={onEdit}
            // name="编辑"
            name={Locale["Edit"]}
        />
        <AuthButton
            // resCode="maintenanceView"
            resCode={ResourcesAuthBtn[mianCode]["MaintenanceView"]}
            onClick={onLook}
            // name="查看"
            name={Locale["View"]}
        />
        <AuthButton
            // resCode="maintenancePayment"
            resCode={ResourcesAuthBtn[mianCode]["MaintenancePayment"]}
            onClick={onSettle}
            // name="结算"
            name={Locale["Settle"]}
        />
        <AuthButton
            // resCode="maintenanceStockout"
            resCode={ResourcesAuthBtn[mianCode]["MaintenanceStockout"]}
            onClick={onWhConfirm}
            // name="出库"
            name={Locale["Stock out"]}
        />
        <AuthButton
            // resCode="maintenanceCancel"
            resCode={ResourcesAuthBtn[mianCode]["MaintenanceCancel"]}
            onClick={cancellation}
            // name="作废"
            name={Locale["Cancel"]}
        />
        <AuthButton
            // resCode="maintenanceCancel"
            // resCode={ResourcesAuthBtn[mianCode]["MaintenanceDetailsApproval"]}
            resCode={ResourcesAuthBtn[mianCode]["MaintenanceDetailsApproval"]}
            onClick={approval}
            // name="退单"
            name={Locale["Chargeback"]}
        />
        <AuthButton
            // resCode="maintenanceCancel"
            // resCode={ResourcesAuthBtn[mianCode]["MaintenanceDetailsPassed"]}
            resCode={ResourcesAuthBtn[mianCode]["MaintenanceDetailsPassed"]}
            onClick={passed}
            // name="退单审核"
            name={Locale["Chargeback approval"]}
        />
        <AuthButton
            resCode={ResourcesAuthBtn[mianCode]["MaintenancePrint"]}
            onClick={onQuotationPrint}
            name={Locale["Quotation Print"]}
        />
         <AuthButton
            resCode={ResourcesAuthBtn[mianCode]["MaintenancePrint"]}
            onClick={onSaleBillPrint}
            name={Locale["SaleBill Print"]}
        />
        <Dropdown overlay={MenuExport}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
            >{Locale["export"]}<DownOutlined /></Button>
        </Dropdown>
    </>;
    const desc: IDescription[] = [
        {
            // label: "工时费",
            label: Locale["Labor Cost"],
            value: selectedRowKeys.length === 0 ? descTotal.workingHoursAmount : formatNum(rowsDescTotal.workingHoursAmount),
            color: DescriptionColorEnum.red
        },
        {
            // label: "材料费",
            label: Locale["Material Cost"],
            value: selectedRowKeys.length === 0 ? descTotal.materialScienceAmount : formatNum(rowsDescTotal.materialScienceAmount),
            color: DescriptionColorEnum.red
        },
        {
            // label: "优惠金额",
            label: Locale["Discount Amount"],
            value: selectedRowKeys.length === 0 ? descTotal.discountTotalAmount : formatNum(rowsDescTotal.discountTotalAmount),
            color: DescriptionColorEnum.red
        },
        {
            // label: "总计金额",
            label: Locale["Total amount"],
            value: selectedRowKeys.length === 0 ? descTotal.totalAmount : formatNum(rowsDescTotal.totalAmount),
            color: DescriptionColorEnum.red
        },
        {
            // label: "应收金额",
            label: Locale["Receivable Amount"],
            value: selectedRowKeys.length === 0 ? descTotal.receivableTotalAmount : formatNum(rowsDescTotal.receivableTotalAmount),
            color: DescriptionColorEnum.red
        },
        {
            // label: "已收金额",
            label: Locale["Received Amount"],
            value: selectedRowKeys.length === 0 ? descTotal.amountReceived : formatNum(rowsDescTotal.amountReceived),
            color: DescriptionColorEnum.red
        },
    ]
    return (
        <YhBox title={<></>} descriptions={desc} action={action} >
            <DataTable />
        </YhBox>
    )
}